import { motion, Variants } from "framer-motion";

interface InViewAnimationProps {
  direction?: keyof typeof initialPositionMap;
  delay?: number;
  duration?: number;
}

const initialPositionMap = {
  top: { y: -50 },
  bottom: { y: 50 },
  left: { x: -50 },
  right: { x: 50 },
  none: {},
};

const variants: Variants = {
  initial: (direction: keyof typeof initialPositionMap) =>
    direction ? { opacity: 0, ...initialPositionMap[direction] } : {},
  inView: { opacity: 1, y: 0, x: 0 },
};

export const InViewAnimation: React.FC<InViewAnimationProps> = ({
  direction = "none",
  delay = 0.4,
  duration = 1.2,
  children,
}) => {
  return (
    <motion.div
      initial="initial"
      whileInView="inView"
      transition={{ delay, duration }}
      variants={variants}
      custom={direction}
      viewport={{ margin: "-5% 0px -15% 0px" }}
    >
      {children}
    </motion.div>
  );
};
